import { ErrorContext, Log } from "Utils/sentryLogUtils";
import { select, takeEvery } from "redux-saga/effects";
import { alertError, fieldInputError } from "./errorDisplayedSlice";

import { Extras } from "@sentry/types";
import { CAR_FIND_STEP } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/carSteps";
import { AlertType } from "Components/Form/Alert";
import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";
import { ReduxState } from "Store/rootReducer";
import { isDefined } from "Utils/functions";
import { ErrorDisplayedState } from "./errorDisplayedInterface";

type AllActionFailedTypes = typeof fieldInputError | typeof alertError;

const formStatesSelector = (state: ReduxState): FormStates =>
  state.priceCalculation.priceCalculationFormStates;

export function* errorDisplayed(
  sagaAction: ReturnType<AllActionFailedTypes>,
): any {
  const formStates = yield select(formStatesSelector);
  const name = sagaAction.type;
  const actionPayload = sagaAction.payload;

  try {
    const errorContext = getErrorContext(actionPayload, sagaAction, formStates);
    const alertType = sagaAction.payload.fieldInfo?.alertType;
    if (
      name === "actionFailed/alertError" &&
      isDefined(alertType) &&
      alertType === AlertType.SYSTEM_ERROR_ALERT
    ) {
      yield Log.error(name, errorContext);
    }
  } catch (e) {
    // Do nothing if logging fails for some reason.
  }
}

const getErrorContext = (
  errorMessage: ErrorDisplayedState,
  sagaAction: ReturnType<AllActionFailedTypes>,
  formStates: FormStates,
): ErrorContext => {
  const actionType = sagaAction.type;
  const productName = sagaAction.payload.fieldInfo?.productName;
  const id = sagaAction.payload.fieldInfo?.fieldId;
  const stepId = sagaAction.payload.fieldInfo?.stepId;

  return {
    tags: {
      actionType,
      ...(productName && { productName }),
      ...(stepId && { stepId }),
      ...supplementaryTags(formStates, id),
    },
    extras: errorMessage as Extras,
  };
};

interface Tags {
  alertId?: string;
  brand?: string;
  licensePlateNumber?: string;
  model?: string;
  modelYear?: string;
}

const supplementaryTags = (formStates: any, alertId?: string): Tags => {
  if (formStates && formStates[CAR_FIND_STEP.id]) {
    const state = formStates[CAR_FIND_STEP.id];
    return {
      alertId: `${alertId}`,
      brand: `${state.brand}`,
      licensePlateNumber: `${state.licensePlateNumber}`,
      model: `${state.model}`,
      modelYear: `${state.modelYear}`,
    };
  }
  return {};
};

export function* errorDisplayedSaga(): Generator {
  yield takeEvery([fieldInputError, alertError], errorDisplayed);
}
